












import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import SpaIndicator from '../../atoms/Indicator.vue'

@Component({
  components: {
    SpaIndicator,
  },
})
export default class CancelIndicator extends Vue {
  @Prop()
  currentIndex: number

  get sequences() {
    return {
      1: 'キャンセル内容入力',
      2: 'キャンセル完了',
    }
  }
}
